<style lang="stylus">
    .filesitem-select-grid
        position absolute
        left 6px
        top 6px
        display none
        align-items center
        justify-content center
        width 24px
        height 24px
        cursor pointer
        z-index 1

        &.selected
            display flex

        .select-icon
            display inline-block
            width 16px
            height 16px
            background-color #fff
            border-radius 100%
            border 1px solid #ccc
            &:hover
                border 1px solid #017FFF


    .filesitem-tag
        display none
        position absolute
        max-width 100px
        left 8px
        top 105px
        height 24px
        background #fafafe
        border-radius 4px
        text-align center
        line-height 24px
        font-size 12px
        align-items center
        &.keep-expand
            display flex
        p
            display inline
            padding-left 6px
            padding-right 18px
            text-overflow ellipsis
            white-space nowrap
            overflow hidden
        svg
            color #757575
            position absolute
            right 5px
            width 8px
            height 8px
        &.active,&:hover
            background #f1f3fb
    .filesitem-taglist
        position absolute
        left 8px
        top 133px
        min-width 68px
        max-width 160px
        background #fff
        border 0.5px solid rgba(0, 0, 0, 0.06)
        box-shadow 0px 5px 12px rgba(0, 0, 0, 0.08)
        border-radius 8px
        padding 6px
        z-index 3
        li
            height 28px
            text-align center
            line-height 28px
            transition background .2s linear
            border-radius 4px
            &:hover
                background #F5F7F6
            p
                color #515A6E
                font-size 13px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
    .filesitem-viewonly
        position absolute
        max-width 80px
        height 24px
        left 0
        top 0
        padding 0 8px
        display flex
        justify-content center
        align-items center
        background linear-gradient(99deg, #67D7FF 18.03%, #0167FF 100%);
        border-radius 8px 0
        font-size 13px
        line-height 16px
        color #fff
        p
            display inline
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
        &.primary
            background linear-gradient(99.06deg, #67D7FF 18.03%, #0167FF 100%)
    .filesitem-notes
        display none
        position absolute
        right 0
        top 0
        background: linear-gradient(92.45deg, #CBCED7 0%, #ADB3C2 100%)
        border-radius 0px 6px
        font-size 12px
        line-height 12px
        color #fff
        padding 4px 8px
    .dark-theme__taglist
        background: #3F3F41;
        border: 0.5px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.03), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0178832), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0121168)
        li
            &:hover
                background rgba(255, 255, 255, 0.08)
            p
                color #fff
    .filesitem-onlyviewcover
        display none
        flex-wrap wrap
        align-content flex-start
        justify-content center
        position absolute
        left 0
        top 0
        width 196px
        height 136px
        background rgba(0, 0, 0, 0.4)
        border-radius 6px 6px 0 0
        .onlyviewcover-btn
            display flex
            justify-content center
            align-items center
            width 150px
            height 28px
            border-radius 6px
            font-size 12px
            line-height 16px
            &.vip
                background: linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
                color #402300
                font-weight 500
                cursor pointer
                user-select none
                margin-top 48px
                margin-bottom 8px
                &:hover
                    background linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
            &.white
                color #FFFFFF
                pointer-events none
                &:hover
                    color rgba(255, 255, 255, 0.5)
    .pcview-select-grid
        position absolute
        left 10px
        top 10px
        display none
        align-items center
        justify-content center
        width 24px
        height 24px
        cursor pointer
        z-index 1
        &:hover
            &:after
                display block

        &.selected
            display flex

        &:after
            display none
            content ''
            position absolute
            left 5px
            top 5px
            width 14px
            height 14px
            border 1px solid #017fff
            border-radius 2px
            pointer-events none

        .select-icon
            display inline-block
            width 16px
            height 16px
            background-color #fff
            border-radius 100%
            border 1px solid #ccc
            &:hover
                border 1px solid #017FFF
</style>
<template>
    <div style="position: absolute; left: 0; top: 0; width: 100%">
        <template v-if="isNewPcView">
            <div
                class="pcview-select-grid"
                v-if="!pcSaveInput"
                :class="{ selected: isSelcted }"
                @mousedown.stop=""
                @click.stop="selectEvent(fileIndex)"
            >
                <img :src="require(`@/home/assets/pcview/check${isSelcted ? '-active' : ''}.svg`)" alt="" />
            </div>
            <div class="filesitem-viewonly primary" v-show="edit && !['recycle', 'team', 'publishFile'].includes(type) && !vip && !isSelcted">
                <p :title="$t('editor')">{{ $t("editor") }}</p>
            </div>

            <div class="filesitem-onlyviewcover" v-if="edit === false && !['recycle'].includes(type) && !isSelcted">
                <div class="onlyviewcover-btn vip" @click.stop="toBuy">{{ $t("onlyview-edit") }}</div>
                <div class="onlyviewcover-btn white">{{ $t("onlyview-view") }}</div>
            </div>

            <div
                ref="filestagselector"
                v-if="!pcSaveInput"
                v-show="!['recycle', 'openRecord', 'star'].includes(type)"
                class="filesitem-tag"
                :class="{ active: showTagList, 'keep-expand': fileTagStr != $t('tag') }"
                @click.stop="tagFunc('expand')"
                @dblclick.stop=""
            >
                <p :title="fileTagStr">{{ fileTagStr }}</p>
                <iconSymbol name="filesitem-tagarrow" />
            </div>

            <ul class="filesitem-taglist" :class="{ 'dark-theme__taglist': isPCDarkMode == 2 }" v-if="showTagList">
                <li v-for="(item, index) in tagList" :key="item.id" @click.stop="tagFunc('select', { index })">
                    <p :title="$t(item.label)">{{ $t(item.label) }}</p>
                </li>
            </ul>
            <div v-if="type == 'recycle'" class="filesitem-notes">{{ $t("expireDate", { date: remainTime }) }}</div>
        </template>
        <template v-else>
            <div
                class="filesitem-select-grid"
                v-if="!pcSaveInput"
                :class="{ selected: isSelcted }"
                @mousedown.stop=""
                @click.stop="selectEvent(fileIndex)"
            >
                <i v-show="!isSelcted" class="select-icon"></i>
                <img v-show="isSelcted" :src="require('@/home/assets/img/files/select-active.svg')" alt="" />
            </div>
            <template v-if="isPC">
                <div class="filesitem-viewonly primary" v-show="edit && !['recycle'].includes(type) && !vip && !isSelcted">
                    <p :title="$t('editor')">{{ $t("editor") }}</p>
                </div>
            </template>
            <template v-else>
                <div class="filesitem-viewonly" v-show="edit === false && !['recycle'].includes(type) && !isSelcted">
                    <p :title="$t('read')">{{ $t("read") }}</p>
                </div>
            </template>
            <div
                ref="filestagselector"
                v-show="!['recycle', 'openRecord', 'star'].includes(type)"
                class="filesitem-tag"
                :class="{ active: showTagList, 'keep-expand': fileTagStr != $t('tag') }"
                @click.stop="tagFunc('expand')"
                @dblclick.stop=""
            >
                <p>{{ fileTagStr }}</p>
                <iconSymbol name="filesitem-tagarrow" />
            </div>
            <ul class="filesitem-taglist" :class="{ 'dark-theme__taglist': isPCDarkMode == 2 }" v-if="showTagList">
                <li v-for="(item, index) in tagList" :key="item.id" @click.stop="tagFunc('select', { index })">
                    <p :title="$t(item.label)">{{ $t(item.label) }}</p>
                </li>
            </ul>
            <div v-if="type == 'recycle'" class="filesitem-notes">{{ $t("expireDate", { date: remainTime }) }}</div>

            <div class="filesitem-onlyviewcover" v-if="edit === false && !['recycle'].includes(type) && !isSelcted">
                <div class="onlyviewcover-btn vip" @click.stop="toBuy">{{ $t("onlyview-edit") }}</div>
                <div class="onlyviewcover-btn white">{{ $t("onlyview-view") }}</div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    class Expander {
        dom;
        expandCallBack;
        clickCallBack;
        closeCallBack;

        constructor(dom: HTMLElement, expandCallBack: object, clickCallBack: object, closeCallBack: object) {
            this.dom = dom;
            this.expandCallBack = expandCallBack;
            this.clickCallBack = clickCallBack;
            this.closeCallBack = closeCallBack;
        }
        expand() {
            this.expandCallBack && this.expandCallBack();
            window.addEventListener("click", this.close);
        }
        select(args) {
            this.clickCallBack && this.clickCallBack(args);
            window.removeEventListener("click", this.close);
        }
        close = (e) => {
            let objTarget = this.dom;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.closeCallBack && this.closeCallBack();
                window.removeEventListener("click", this.close);
            }
        };
    }
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class GridFileExpand extends Vue {
        @Prop() fileSelected: Array<number>;
        @Prop() fileIndex: number;
        @Prop() fileTagStr: string;
        @Prop() type: string;
        @Prop() edit: boolean;
        @Prop() pcSaveInput: boolean;
        @Prop() remainTime: string;

        tagList: Array<any> = [
            {
                id: 1,
                value: "edraw_1",
                label: "waitdone",
            },
            {
                id: 2,
                value: "edraw_2",
                label: "done",
            },
            {
                id: 3,
                value: "edraw_3",
                label: "waitchange",
            },
            {
                id: 4,
                value: "",
                label: "custom",
            },
            {
                id: 0,
                value: "edraw_0",
                label: "none",
            },
        ];
        showTagList: boolean = false;
        tagExpander: any = null;

        get isSelcted() {
            return this.fileSelected.includes(this.fileIndex);
        }

        selectEvent(index) {
            this.$emit("selectEvent", index);
        }
        clickTagList() {
            this.showTagList = true;
        }
        documentClick() {
            var event = document.createEvent("MouseEvents");
            event.initMouseEvent("click", true, true, document.defaultView, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            document.body.dispatchEvent(event);
        }
        tagFunc(type, args) {
            if (!this.tagExpander) {
                let dom = this.$refs.filestagselector as HTMLElement;
                let expand = () => {
                    if (this.$store.state.activeFileItemIndex != this.fileIndex) {
                        this.documentClick();
                    }
                    this.$emit("expandTag");
                    this.$store.commit("setState", {
                        type: "activeFileItemIndex",
                        data: this.fileIndex,
                    });
                    this.showTagList = !this.showTagList;
                };
                let select = (args) => {
                    let { index } = args;
                    this.showTagList = false;
                    if (index == 3) {
                        this.$emit("expandCustomTag");
                    } else {
                        this.$emit("changeTagStr", this.tagList[index].value);
                    }
                };
                let close = () => {
                    this.showTagList = false;
                };
                this.tagExpander = new Expander(dom, expand, select, close);
            }
            if (type == "expand") {
                this.tagExpander.expand();
            } else if (type == "select") {
                this.tagExpander.select(args);
            }
        }
        toBuy() {
            this.$openBuyPage();
        }

        get isNewPcView() {
            return this.isPC && this.$isBiggerVersion("13.0.0");
        }

        beforeDestroy() {
            this.tagExpander = null;
        }
        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "tag": "标签",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "custom": "自定义",
    "read": "仅预览",
    "editor": "可编辑",
    "expireDate": "{date}天后永久删除",
    "onlyview-edit": "编辑",
    "onlyview-view": "仅预览"
  },
  "en": {
    "tag": "Tag",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "custom": "Customize",
    "read": "View only",
    "editor": "Editable",
    "expireDate": "Permanently deleted after {date} days",
    "onlyview-edit": "Edit",
    "onlyview-view": "Preview only"
  },
  "fr": {
    "tag": "étiqueter",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié",
    "custom": "Personnalisé",
    "read": "Voir seulement",
    "editor": "Modifiable",
    "onlyview-edit": "Modifier",
    "onlyview-view": "Aperçu uniquement"
  },
  "de": {
    "tag": "Etikette",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar",
    "custom": "Benutzerdefiniert",
    "read": "Nur anschauen",
    "editor": "Editierbar",
    "onlyview-edit": "Bearbeiten",
    "onlyview-view": "Nur Vorschau"
  },
  "jp": {
    "tag": "ラベル",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定",
    "custom": "カスタマイズ",
    "read": "閲覧のみ",
    "editor": "編集可能",
    "onlyview-edit": "編集",
    "onlyview-view": "プレビューのみ"
  },
  "es": {
    "tag": "etiqueta",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar",
    "custom": "Personalizar",
    "read": "Sólo vista",
    "editor": "Editable",
    "onlyview-edit": "Editar",
    "onlyview-view": "Solo vista previa"
  },
  "pt": {
    "tag": "rótulo",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado",
    "custom": "personalizada",
    "read": "Apenas ver",
    "editor": "Editável",
    "onlyview-edit": "Editar",
    "onlyview-view": "Somente visualização"
  },
  "it": {
    "tag": "etichetta",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare",
    "custom": "Personalizza",
    "read": "Visualizzare solamente",
    "editor": "Modificabile",
    "onlyview-edit": "Modifica",
    "onlyview-view": "Solo anteprima"
  },
  "tw": {
    "tag": "標籤",
    "none": "無",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "custom": "自定義",
    "read": "僅查看",
    "editor": "可編輯",
    "onlyview-edit": "編輯",
    "onlyview-view": "僅供預覽"
  },
  "kr": {
    "tag": "태그",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요함",
    "custom": "태그 지정",
    "read": "보기만 가능",
    "editor": "편집 가능",
    "onlyview-edit": "편집",
    "onlyview-view": "미리 보기 전용"
  },
  "id": {
    "tag": "Tag",
    "none": "Tidak",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi",
    "custom": "Kustomisasi",
    "read": "Hanya lihat",
    "editor": "Edit",
    "onlyview-edit": "Edit",
    "onlyview-view": "Pratinjau saja"
  }
}
</i18n>
